import { render, staticRenderFns } from "./DeleteEntities.vue?vue&type=template&id=36f60d29&scoped=true&"
import script from "./DeleteEntities.vue?vue&type=script&lang=js&"
export * from "./DeleteEntities.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEntities.vue?vue&type=style&index=0&id=36f60d29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f60d29",
  null
  
)

export default component.exports